import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';

import App from './app.vue';

import "./static/styles/baseStyle.scss";
import "./static/styles/fonts.scss";

Vue.use(VueScrollTo);

new Vue({
    el: '#main',
    template: '<App/>',
    components: { App },
    mounted: function() {
        console.log('%c Bonus !! Try to call applyJob() in the console ',
                    'line-height:40px; font-size:20px; background: #afc01c; color: #ffffff');
    }
});

window.applyJob = function () {
    console.log('%c恭喜你獲得通關密語', 'font-size:18px; color: #333');
    console.log('%c八仙過海，各顯神通',
                'font-size:30px; background: #afc01c; color: #ffffff');
    console.log('%c別忘了在應徵問卷留言處，加上通關密語唷', 
                'font-size:18px; color: #333');
}



// WEBPACK FOOTER //
// ./src/main.js